// extracted by mini-css-extract-plugin
export default {"box":"viewer-inner-panel_box__A-A7M"};